export default __webpack_public_path__ + "static/media/complementary--trees--g1.26a10d2b.png";